import { render } from "./Conversation.vue?vue&type=template&id=ac349462&scoped=true&ts=true"
import script from "./Conversation.vue?vue&type=script&lang=ts"
export * from "./Conversation.vue?vue&type=script&lang=ts"

import "./Conversation.vue?vue&type=style&index=0&id=ac349462&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac349462"]])

export default __exports__